// extracted by mini-css-extract-plugin
module.exports = {"initImg":"ArtworkShareModal_initImg__3Z93z","initImgTxt":"ArtworkShareModal_initImgTxt__vWW_D"};